import type { ApiVolop } from '#/modules/listing/volops/api/types/ApiVolop';
import type { OrgDashboardApiVolop } from '#/modules/orgDashboard/api/listing/types/OrgDashboardApiVolop';
import type { StaffApiVolop } from '#/modules/staff/listings/volops/api/types/StaffApiVolop';
import type { DatetimeString } from '#/types/TypedDateString';

/**
 * This is a simple helper that exists to represent the logic for volops,
 * making sure we update all places where it's used
 */
export function getVolopPublishedDate(
  volop: ApiVolop | OrgDashboardApiVolop | StaffApiVolop,
): DatetimeString | null {
  return volop.lastPublished || volop.firstPublished;
}
